import { DatePicker, Loading } from "components";
import { AlertType, ConfigDataType } from "interfaces";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Button,
  Card,
  Checkbox,
  Form,
  Input,
  TextArea,
} from "semantic-ui-react";
import { api, ui } from "services";

export default function Setting() {
  const { name } = useParams();
  const [config, setConfig] = useState<any>(null);
  const [isRedis, setIsRedis] = useState(false);

  useEffect(() => {
    setIsRedis(false)
  }, [name])

  useEffect(() => {
    async function loadConfig() {
      let host = isRedis ? '/operation/get-config-redis' : '/operation/api/get-config'
      let rs = await api.post(host, { where: { name } });
      if (rs.data[0].value === null) {
        ui.alert("This config does not exist in redis yet !", AlertType.Warning)
      }
      setConfig(rs.data[0]);
    }
    loadConfig();
  }, [name, isRedis]);
  async function update() {
    let host = isRedis ? '/operation/update-config-redis' : '/operation/api/update-config'
    let rs = await api.post(host, config);
    setConfig(rs);
    ui.alert("Update success");
  }
  function handleChange(name: string, value: any) {
    let tmp = _.cloneDeep(config);
    tmp[name] = value;
    setConfig(tmp);
  }
  function renderContent() {
    if (!config) {
      return <Loading />;
    }
    switch (config.type) {
      case ConfigDataType.Boolean:
        return (
          <div>
            <Checkbox
              toggle
              checked={config.value === "1"}
              onChange={(evt: any, { checked }) => {
                handleChange("value", checked ? "1" : "0");
              }}
            />
          </div>
        );
      case ConfigDataType.Date:
        return (
          <div>
            <DatePicker
              showTimeSelect
              dateFormat="yyyy/MM/dd HH:mm:ss"
              todayButton="Today"
              selected={config ? new Date(config.value) : null}
              onChange={(val: any) => {
                handleChange("value", val);
              }}
            />
            <p className="text-red-600 font-semibold">
              Display in local time (+
              {(new Date().getTimezoneOffset() / 60) * -1})
            </p>
          </div>
        );
      case ConfigDataType.Number:
        return (
          <div>
            <Input
              type="text"
              value={config?.value || ""}
              onChange={(evt: any) => {
                handleChange("value", evt.target.value);
              }}
            />
          </div>
        );
      case ConfigDataType.Object:
        return (
          <TextArea
            type="text"
            value={config?.value || ""}
            onChange={(evt: any) => {
              handleChange("value", evt.target.value);
            }}
          />
        );
      case ConfigDataType.String:
        return (
          <Input
            type="text"
            value={config?.value || ""}
            onChange={(evt: any) => {
              handleChange("value", evt.target.value);
            }}
          />
        );
    }
  }
  return (
    <div>
      <Card fluid>
        <Card.Content>
          <Card.Header>
            <div className="flex justify-between">
              <p>Edit Config {`${isRedis ? "(Redis)" : ""}`}</p>
              <div>
                <Button
                  icon="exchange"
                  content={isRedis ? "Convert to Database mode" : "Convert to Redis mode"}
                  color={isRedis ? 'green' : 'yellow'}
                  onClick={() => {
                    setIsRedis(!isRedis)
                  }}
                  labelPosition="left"
                />
                <Button
                  icon="save"
                  content={isRedis ? "Save redis" : "Save"}
                  primary
                  onClick={() => {
                    update();
                  }}
                  labelPosition="left"
                />
              </div>
            </div>
          </Card.Header>
        </Card.Content>
        <Card.Content>
          <p className="text-3xl font-semibold">{config?.name}</p>
          <p>Description</p>
          <Input
            type="text"
            fluid
            value={config?.description || ""}
            onChange={(evt: any) => {
              let tmp = _.cloneDeep(config);
              tmp.description = evt.target.value;
              setConfig(tmp);
            }}
          />
          <Form className="mt-4">
            <Form.Field>
              <label>Value</label>
              {renderContent()}
            </Form.Field>
          </Form>
          <div className="mt-4"></div>
        </Card.Content>
      </Card>
    </div>
  );
}
